<template> 
    <div > 
        <div class="crumbs" hidden="true" style="margin-left:10px;" >
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-calendar"></i> 商品管理
                </el-breadcrumb-item>
                 <el-breadcrumb-item>产品配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" style="border: none;" v-loading="loading2" element-loading-text="正在保存商品数据" element-loading-spinner="el-icon-loading">
            <div  style="border: 1px dashed #409EFF;background:#ecf5ff;padding:15px 10px;margin-top:-30px;">
                    <span class="label-span">
                        <label class="label2">下游渠道</label> 
                        <el-select v-model="query2.mids"   placeholder="下游渠道" filterable clearable style="width:120px;" class="handle-input mr10">
                            <el-option value="" label="全部"  />  
                            <el-option v-for="item in select3.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                        </el-select> 
                    </span>       
                    <span class="label-span">
                        <label class="label2">限单方式</label> 
                        <el-select v-model="query2.giveType"  placeholder="分类状态" clearable style="width:100px;" class="handle-select mr10">
                            <el-option value="" label="全部"  />  
                            <el-option value="0" label="不限单量"  /> 
                            <el-option value="1" label="定额分配"  /> 
                            <el-option value="2" label="大盘抢单"  /> 
                        </el-select> 
                    </span>     
                    <span class="label-span">
                        <label class="label2">是否风控</label> 
                        <el-select v-model="query2.isRisk"  placeholder="分类状态" clearable style="width:100px;" class="handle-select mr10">
                            <el-option value="" label="全部"  />  
                            <el-option value="0" label="未风控"  /> 
                            <el-option value="1" label="已风控"  /> 
                        </el-select> 
                    </span>    
                    <span class="label-span">
                        <label class="label2">是否扣量</label> 
                        <el-select v-model="query2.isDeduc"  placeholder="分类状态" clearable style="width:100px;" class="handle-select mr10">
                            <el-option value="" label="全部"  />  
                            <el-option value="0" label="未扣量"  /> 
                            <el-option value="1" label="已扣量"  /> 
                        </el-select> 
                    </span>    
                    <span class="label-span">
                        <label class="label2">是否分配</label> 
                        <el-select v-model="query2.status"  placeholder="分类状态" clearable style="width:100px;" class="handle-select mr10">
                            <el-option value="" label="全部"  />  
                            <el-option value="0" label="未分配"  /> 
                            <el-option value="1" label="已分配"  /> 
                        </el-select> 
                    </span>   
                    <el-button type="success" size="small" @click="handleSearch2">搜索</el-button>
                    <el-button type="warning" size="small" @click="refreshSearch2">重置</el-button> 
                    <el-tooltip  content="点击解开编辑权限" placement="top">
                        <i style="color:#fff;font-size:25px;vertical-align:middle;cursor:pointer;color: #409eff;float:right;margin-right:20px;" class='el-icon-edit-outline'  @click="setConfigEdit()"></i>
                    </el-tooltip>

                <el-table   :data="tableData2" :stripe="true" size="mini" border class="table" header-cell-class-name="table-header"
                v-loading="loading4" style="margin-top:15px"  element-loading-text="请稍等..." element-loading-spinner="el-icon-loading" >  
                    <el-table-column prop="gid"  width="210" align="left" label="渠道信息">
                        <template slot-scope="scope" >
                            <p style="font-size:13px;"> 
                                渠道名称：{{scope.row.loginName}} ({{scope.row.memId}})<br>
                                产品编码：<el-link type="primary" style="font-size:12px" @click="copyLink('产品编码','产品编码:'+scope.row.goodsCode)" ><b>{{scope.row.goodsCode}}</b></el-link><br>
                                下游编码：<input class='inputStyle'  v-model.trim="scope.row.memGoodsCode" :disabled="config.edit" @change="handleVal(scope.row)" placeholder="下游编码"  style="width:100px; "  >
                    
                            </P>     
                        </template>    
                    </el-table-column>
                    <el-table-column prop="isSm" min-width="200" align="left" label="投放信息设置">
                        <template slot-scope="scope" >
                            <p style="font-size:13px;">
                                投放平台（中文）<input  v-model.trim="scope.row.platform"   @change="handleVal(scope.row)" :disabled="config.edit" placeholder="投放平台" style="width:calc(100% - 115px);" class="inputStyle" /> <br>
                                投放触点（中文）<input  v-model.trim="scope.row.contact"   @change="handleVal(scope.row)" :disabled="config.edit" placeholder="投放触点" style="width:calc(100% - 115px);" class="inputStyle" /> <br>
                                app 包名（英文）<input  v-model.trim="scope.row.appPackage"  @change="handleVal(scope.row)" :disabled="config.edit" placeholder="app 包名" style="width:calc(100% - 115px);" class="inputStyle" />
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="channelComType" width="140" align="left" label="佣金设置">
                        <template slot-scope="scope" >
                            <p style="font-size:13px;">
                                上游佣金：<span class='orangered'>￥{{scope.row.channelCom}}</span>
                                <br>下游结算：<b class="red">￥{{formatNumber(scope.row.goodsCom)}}</b>
                                <br><span class='tableOperBtn' @click="priceHis(scope.$index, scope.row)" ><i class='el-icon-edit-outline'></i> CPA结算调整</span>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="gid"  width="180" align="left" label="扣量设置">
                        <template slot-scope="scope" >
                            <p style="font-size:13px;line-height:25px;">
                                扣量比例：<input
                                class="inputStyle"
                                v-model.number="scope.row.deducPercent"
                                :disabled="config.edit"
                                @change="setDeduc(scope.row)"
                                placeholder="扣量比例"
                                style="width:50px;"
                                oninput="value = Math.max(0, Math.min(100, value.replace(/[^0-9]/g, '')))"
                                min="0"
                                max="100"

                            />  %
                            <br>
                                扣量开始：{{scope.row.deducTime}}
                                
                            </P>     
                        </template>    
                    </el-table-column>  
                    <el-table-column prop="gid"  width="200" align="left" label="限单设置">
                        <template slot-scope="scope" >
                            <p style="font-size:13px;"> 
                                总限单量：&nbsp;&nbsp;&nbsp;&nbsp;{{form4.limitNum}}<br>
                                限单方式：<el-select v-model="scope.row.giveType" :disabled="config.edit" @change="handleVal(scope.row)" placeholder="限单方式" style="width:100px;" class="handle-select">
                                            <el-option value="0" label="不限单量"  />  
                                            <el-option value="1" label="定额分配"  /> 
                                            <el-option value="2" label="大盘抢单"  /> 
                                        </el-select>   
                            <br>
                                限单数量：<span v-if='scope.row.giveType==2' style="color:red;margin-top:-10px;font-weight:700"> 抢 </span>
                                <span v-if='scope.row.giveType==1' style="color:blue;font-weight:700"> 限 </span> 
                                <input v-if="scope.row.giveType==2 || scope.row.giveType==1"  class='inputStyle' :disabled="config.edit" @change="handleVal2(scope.row)" v-model.trim="scope.row.giveNum" style="width:60px;margin-left:0px;"  placeholder="限单数量" oninput="value=value.replace(/[^0-9.]/g,'')"  > 
                                <span v-if='scope.row.giveType==0' style="color:green;font-weight:700;margin-left:20px;"> 不限 </span>
                             <br>   
                               
                            </P>     
                        </template>    
                    </el-table-column>    
                    <el-table-column prop="isSm" width="200" align="left" label="渠道风控">
                        <template slot-scope="scope" > 
                            <p style="font-size:13px;"> 
                            整体风控值:{{form4.riskTotal}} - {{form4.riskRate}}%
                                <el-tooltip :content="scope.row.riskStatus=='1'?'风控关停':'风控通过'" placement="top">
                                <el-switch @change="handleStatus4(scope.row)"
                                           v-model="scope.row.riskStatus"
                                           active-color=""
                                           inactive-color="red"
                                           active-value="0"
                                           inactive-value="1">
                                </el-switch>
                            </el-tooltip><br>
                            渠道风控值：<input  v-model.trim="scope.row.riskNum" oninput="value=value.replace(/[^0-9.]/g,'')" @change="setMemRiskConfig(scope.row)" :disabled="config.edit" placeholder="渠道风控值" style="width:85px;" class="inputStyle" />
                            <br>
                            渠道转化率：<input  v-model.trim="scope.row.riskPercent" oninput="value=value.replace(/[^0-9.]/g,'')" @change="setMemRiskConfig(scope.row)" :disabled="config.edit" placeholder="渠道转化率" style="width:70px;" class="inputStyle" /> %
                        
                            </p>
                        </template>  
                    </el-table-column>
                    <el-table-column prop="status" align="center" width="140" label="当前状态">
                        <template slot-scope="scope" >
                            <p style="font-size:13px;line-height:30px;">
                            分配状态：<el-tooltip :content="scope.row.status=='1'?'已分配':'未分配'" placement="top">
                                        <el-switch @change="value=>handleStatus2(scope.$index,scope.row,value)"
                                                   v-model="scope.row.status"
                                                   active-color=""
                                                   inactive-color=""
                                                   active-value="1"
                                                   inactive-value="0">
                                        </el-switch>
                                    </el-tooltip>
                            <br> 到量状态：<el-tooltip :content="scope.row.isStop=='1'?'已到量':'未到量'" placement="top">
                                <el-switch @change="handleStatus3(scope.row)" 
                                    v-model="scope.row.isStop"
                                    active-color=""
                                    inactive-color="red"
                                    active-value="0"
                                    inactive-value="1">
                                </el-switch>
                            </el-tooltip>
                            <br> 专属链接：<el-tooltip :content="scope.row.isLink=='1'?'已开启':'已关闭'" placement="top">
                                <el-switch @change="handleStatus5(scope.row)"
                                    v-model="scope.row.isLink"
                                    active-color=""
                                    inactive-color=""
                                    active-value="1"
                                    inactive-value="0">
                                </el-switch>
                            </el-tooltip>

                            </p>    
                        </template>  
                    </el-table-column>   
                     
                </el-table>  
                <div class="pagination">
                    <el-pagination  background layout="total,  sizes,prev, pager, next,jumper"
                        :page-sizes="[5,10,20]"
                        :current-page="query2.pageIndex"
                        :page-size="query2.pageSize"
                        :total=pageTotal2
                        @size-change="handleSizeChange2"
                        @current-change="handlePageChange2" 
                    ></el-pagination>
                </div> 
            </div>  
        </div>
        <el-dialog :key="priceHisKey" :close-on-click-modal="false" title="CPA结算调整记录" :modal-append-to-body='false' :visible.sync="priceHisVisible" top="50px" width="1200px">
            <el-row :gutter="24" style="width:102%;">
                <el-col :span="6"  v-for="cash in cashConfig">
                    <el-card  shadow="hover" class="cardDiv" :class="cash.utype == 2?'':'bg_gray'">
                        <p class="center outline height30 mb10 size14 bold">
                            {{
                                cashConfigMap[cash.utype]?cashConfigMap[cash.utype].name:"-"
                            }} ({{cash.uname? cash.uname :cash.uid}})
                            <el-tag :type="cash.utype==4?'danger':'success'">{{cash.utype==4?'成本模式':'利润模式'}}</el-tag></p>

                        <template v-if="cash.utype==4">
                            破解成本：<input v-model="cash.cashNum"  class='inputStyle red notborder' disabled
                                            style="width:60px;"
                                            placeholder="" oninput="value=value.replace(/[^0-9.]/g,'').replace(/^(\d+\.\d{1})\d*$/,'')"  > 元
                            <br>
                            税费成本：<input v-model="cash.cashNum2"  class='inputStyle red mb5 notborder' disabled
                                            style="width:60px;"
                                            placeholder="" oninput="value=value.replace(/[^0-9.]/g,'').replace(/^(\d+\.\d{1})\d*$/,'')"  > 元
                        </template>
                        <template v-else>
                            提成方式：<el-radio-group v-model.trim="cash.cashType" class="mb5"  size="mini" @change="countCpaAmount(cash)"
                        :disabled="cash.utype==1 || cash.utype==3">
                                        <el-radio-button label="1">按比例</el-radio-button>
                                        <el-radio-button label="2">按金额</el-radio-button>
                                    </el-radio-group>
                            <div v-if="cash.cashType == 2">
                                提成额度：<input v-model="cash.cashNum"  class='inputStyle red notborder' @change="countCpaAmount(cash)"
                                                style="width:60px;" :disabled="cash.utype==1 || cash.utype==3"
                                                placeholder="" oninput="value=value.replace(/[^0-9.]/g,'').replace(/^(\d+\.\d{1})\d*$/,'')"  > 元
                            </div>
                            <div v-else>
                                提成比例：<input v-model="cash.cashNum"  class='inputStyle red notborder' @change="countCpaAmount(cash)"
                                                style="width:50px;margin-left:0px;" :disabled="cash.utype==1 || cash.utype==3"
                                                placeholder="" oninput="value=value.replace(/[^0-9.]/g,'').replace(/^(\d+\.\d{1})\d*$/,'')"  > %
                            </div>
                        </template>
                    </el-card>
                </el-col>
            </el-row>
            <div >
                <el-card shadow="hover" class="cardDiv bg_gray mt10 mb10">
                    <p class="inline-block mr25 size14 opacity6" ><i class="el-icon-lx-redpacket_fill va_top red size20"></i> 上游佣金:￥{{tableData2[currentRowIndex]?tableData2[currentRowIndex].channelCom:""}}</p>
                    <p class="inline-block mr25 size14 opacity6" ><i class="el-icon-lx-locationfill va_top red size20"></i> 最高结算:￥{{cpaSettlePrice.maxCPASettlePrice}}</p>
                    <p class="inline-block mr25 size14 opacity6"><i class="el-icon-lx-roundcheckfill va_top orange size20"></i> 建议结算:￥{{cpaSettlePrice.recCPASettlePrice}}</p>
                    <p class="inline-block mr55 size14 opacity6"><i class="el-icon-lx-rechargefill va_top green size20"></i> 建议提成:￥{{cpaSettlePrice.sugCPATierDiff}}</p>
                    <p class="inline-block mr25 size14 black"><i class="el-icon-lx-roundcheckfill va_top orange bold size20"></i> 当前结算:￥{{cpaSettlePrice.currentCPASettlePrice}}</p>
                    <p class="inline-block mr25 size14 black"><i class="el-icon-lx-rechargefill va_top green bold size20"></i> 预计提成:￥{{cpaSettlePrice.estCPATierDiff}}</p>
                    <el-button type="primary" class="fr mt_5" icon="el-icon-lx-roundadd" @click="addBind">调整结算价</el-button>
                </el-card>
                <el-table :data="tableData3" class="table"  ref="multipleTable" header-cell-class-name="table-header"   >
                    <el-table-column prop="rname" min-width="90" align="left" label="历史结算">
                        <template slot-scope="scope">
                            ￥ {{scope.row.beforeNum}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="rname" min-width="90" align="left" label="调整结算">
                        <template slot-scope="scope">
                            <b class="red">￥ {{scope.row.afterNum}}</b>
                        </template>
                    </el-table-column>
                    <el-table-column prop="excuteDay" min-width="135" align="left" label="调整时间"></el-table-column>
                    <el-table-column prop="loginName" min-width="80" align="left" label="操作人"></el-table-column>
                    <el-table-column prop="createTime" min-width="150" align="center" label="创建时间"></el-table-column>
                    <el-table-column prop="rname" min-width="80" align="left" label="执行方式">
                        <template slot-scope="scope">
                            {{scope.row.fb1==0?'暂未执行':scope.row.fb1==1?'系统执行':scope.row.fb1==2?'人工操作':'-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="updateTime" min-width="150" align="center" label="执行时间"></el-table-column>
                    <el-table-column label="操作"  width="85" align="center" >
                        <template slot-scope="scope">
                                <span v-if="scope.row.isExcute==1" tip="已调整的结算数据不可删除"   class='tableOperBtn' style="color:#999 !important;cursor:not-allowed;margin-left:-11px;" ><i class='el-icon-delete'></i> 删除</span>

                                <el-popconfirm v-else title="确定要删除吗？"  class="mr10" @confirm="handDelete(scope.$index, scope.row)">
                                <span slot="reference" class='tableOperBtn' ><i  class='el-icon-delete'></i> 删除</span>
                            </el-popconfirm>
                        </template>
                    </el-table-column>

                </el-table>
                <div class="pagination">
                    <el-pagination
                        background
                        layout="total,  sizes,prev, pager, next,jumper"
                        :page-sizes="[10, 20, 50,200]"
                        :current-page="query3.pageIndex"
                        :page-size="query3.pageSize"
                        :total=pageTotal3
                        @size-change="handleSizeChange3"
                        @current-change="handlePageChange3"
                    ></el-pagination>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="调整结算价" :modal-append-to-body='false' :visible.sync="addPlusVisible" top="0" width="450px">
            <el-form ref="form" :model="form1" label-width="100px" @submit.native.prevent="saveForm3">
                <el-form-item label="调整结算价" >
                    <el-input  v-model.trim="form1.afterNum"  placeholder="必填" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                </el-form-item>
                <el-form-item label="执行方式" >
                    <el-radio-group v-model.trim="form1.excuteMethod" @change="excuteMethodChange">
                        <el-radio-button label="1">立即执行</el-radio-button>
                        <el-radio-button label="2">定时执行</el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="计划生效时间" v-if="form1.excuteMethod === '2'">
                    <el-date-picker v-model.trim="form1.excuteDay" type="date" value-format="yyyy-MM-dd" placeholder="生效日期" style="width:50%" filterable clearable  :picker-options="pickerOptions"> </el-date-picker>
                    <el-time-select v-model="form1.excuteTime" value-format="HH:mm" style="width:50%;" filterable clearable  placeholder="生效时间" :picker-options="{  start: '00:00', step: '00:30', end: '24:00' }"></el-time-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addPlusVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm3">{{ isSubmitting ? '提交中...' : '提交' }}</el-button>
            </span>
        </el-dialog>

         
    </div>
 
</template> 

<script>
import $ from 'jquery' ; 
import bus from '../../components/common/bus';
import {changeGive, changeStatus,getGoodsConfig,setMemRisk } from '../../api/comGoods';    
import {fetchSelect as fetchSelect3,changeVal,setDeducPercent} from '../../api/member';  //渠道名称 
import {fetchDataConfig,changeStatus2,changeStatus3,changeStatus4,changeStatus5,fetchData3,saveForm3,handDelete3} from '../../api/comGoodsMemConfig';
import { fetchList as fetchPAList, handUpdateMore as changePAForm } from '../../api/profitAllocation';  //利润分配
import {fetchUserByIdS} from '../user/comUser';  //员工信息
import {formatNumber } from '@/utils/toolUtiils';  //工具包
import { handDelete } from '@/api/operRole';
export default {

    data() {
        return {
            formatNumber,
            statusPopconfirm:true,
            goodsInfo:{},
            isSubmitting: false, // 是否正在提交
            riskIndexs:[],
            cpaSettlePrice:{
                maxCPASettlePrice:0,
                recCPASettlePrice:0,
                sugCPATierDiff:0,
                currentCPASettlePrice:0,
                estCPATierDiff:0
            },
            cashConfigMap:{
                "1":{name:"上游商务",sort:0},
                "3":{name:"公司管理",sort:1},
                "4":{name:"产品运营",sort:2},
                "2":{name:"下游商务",sort:3},
            },
            cashConfig:[],//提成配置
            currentRowIndex:0,
            goodsCode:'',
            memId:'',
            orderDis:true,
            config:{
                wid:'800px',
                top:'50px',
                edit:true,
            },
            pickerOptions: {
                disabledDate: (time) => {
                    // 禁用今天及之前的所有日期
                    return time.getTime() < Date.now()-24*60*60*1000;
                }
            },
            configVisible:false,
            contentVisible:false,
            sureImgVisible:false, 
            sureImgVisible2:false,
            addPlusVisible:false,
            saveContent:'0',
            contentVal:'',
            infoVisible:false,
            loading:false,
            loading2:false,
            loading3:false, 
            loading4:false,
            priceHisVisible:false,
            priceHisKey:'priceHisKey',
            query2: {
                pageIndex: 1,
                pageSize: 5,
                goodsCode:'',
            },
            query3: {
                pageIndex: 1,
                pageSize: 10,
                goodsCode:'',
                memId:'',
                price:'',
            },
            select3:{
                option:'',
            },
            tableData: [],
            tableData2: [], 
            tableData3: [],
            pageTotal3:0,
            pageTotal2:0,
            skuCodes:[],
            form1:{excuteMethod:'1'},
            form2:{},
            form3:{},
            form4:{},
            idx: -1,
            id: -1
        };
    },
 
    beforeDestroy() {
        // 记得移除监听，避免内存泄漏
        bus.$off('config-set');
    },
    created() { 
        
    },
    //页面加载方法
    mounted: function () { 
        this.getSelect3();
        bus.$on('config-set',  row  => {
            this.goodsInfo = row;
            this.configSet(row);
        });
        
    },
    

    methods: { 
        setEdit(){ 
            if(this.orderDis){
                this.orderDis = false;
            }else{
                this.orderDis = true;
            } 
        },
        setConfigEdit(){ 
            if(this.config.edit){
                this.$confirm('解开编辑权限后，修改的所有数据都将实时保存，确定要解开吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.config.edit = false;
                }) 
            }else{
                this.config.edit = true;
               
            }
        },
        countCpaAmount(cash){
            let currentRow = this.tableData2[this.currentRowIndex];
            if (cash){
                if (cash['utype'] == 4){
                    currentRow['otherAmount'] = cash['cashNum']
                }else if (cash['utype'] == 2){
                    currentRow['withdrawal'] = cash['cashType']
                    currentRow['withdrawalAmount'] = cash['cashNum']
                }
            }
            this.handleVal2(currentRow,()=>{
                this.initCpaSettlePrice(this.tableData2[this.currentRowIndex]);
            });
        },
        handleVal(row){
            changeVal(row).then(res => {   
                if(res.code=='200'){ 
                    this.$notify({ title: '成功', message: row.loginName+'设置成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: row.loginName+'设置失败：'+res.message,duration: 5000, type: 'error' }); 
                }
            });
        },
        handleVal2(row,fun){
            changeVal(row).then(res => {   
                if(res.code=='200'){ 
                    this.getData2(fun);
                    this.$notify({ title: '成功', message: row.loginName+'设置成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: row.loginName+'设置失败：'+res.message,duration: 5000, type: 'error' }); 
                }
            });
        },
        setDeduc(row){
            if(row.deducPercent>100){
                this.$message.error(row.goodsName+'扣量值不能超过100');
                return;
            }
            if (!row.deducPercent) {
                row.deducPercent = 0;
            }
            setDeducPercent(row).then(res => {   
                if(res.code=='200'){  
                    this.getData2();
                    this.$notify({ title: '成功', message: row.loginName+'扣量值设置成功',duration: 1000, type: 'success' });
                }else{ 
                    this.$notify({ title: '失败', message:row.loginName+'扣量值设置失败：'+res.message,duration: 5000, type: 'error' });
                }
            }); 
        },
        configSet(row){      
            this.config.edit = true;
            this.$set(this.config, 'edit',true);
            this.query2.goodsCode = row.goodsCode;
            this.goodsConfig(row);
            // this.profitAllocationConfig(row);
            this.getData2();
            this.configVisible = true;
        }, 
        goodsConfig(row){
            getGoodsConfig(row).then(res => {   
                if(res.code=='200'){  
                    this.form4 = res.data; 
                }else{
                    this.$message.error(res.message); 
                }
            });  
        },
        excuteMethodChange(value){
            let excuteDay = "";
            let excuteTime = "";
            if (value === '1'){
                let currentDate = this.getCurrentDateTime();
                excuteDay = currentDate.year + "-" + currentDate.month + "-" + currentDate.day;
                excuteTime = currentDate.hours + ":" + currentDate.minutes;
            }
            this.$set(this.form1,"excuteDay",excuteDay);
            this.$set(this.form1,"excuteTime",excuteTime);
        },
        profitAllocationConfig(row){
            //原逻辑 新建一张表从数据库中查询，现修改为从产品中查询
            //因此，该方法废弃
            let param = {
                "goodsCode":row.goodsCode
            };
            fetchPAList(param).then(res => {
                this.cashConfig = new Array(Object.keys(this.cashConfigMap).length).fill({});
                if (res['code'] === '200') {
                    for (let item of res.data){
                        this.cashConfig.splice(this.cashConfigMap[item.type].sort, 1, {
                            utype:item.type, //1.上游商务  2.公司管理 3.下游商务 4.产品运营
                            uid:item.uid,
                            uname:item.uname,
                            cashType:item.withdrawal, //提成类型：1按比例 2按金额
                            cashNum:this.formatNumber(item.withdrawalAmount,1),  //提成金额或提成比例
                        });
                    }
                }
            });
        },
        initCpaSettlePrice(row){
            this.$set(this.cpaSettlePrice, 'maxCPASettlePrice', this.formatNumber(row['maxCPASettlePrice']));
            this.$set(this.cpaSettlePrice, 'recCPASettlePrice', this.formatNumber(row['recCPASettlePrice']));
            this.$set(this.cpaSettlePrice, 'sugCPATierDiff', this.formatNumber(row['sugCPATierDiff']));
            this.$set(this.cpaSettlePrice, 'currentCPASettlePrice', this.formatNumber(row['goodsCom']));

            // //计算cpa预计提成
            // //计算公式：预计提成 = 佣金-(上游商务+下游商务+公司管理+税费+杂费)
            // let channelCom = parseFloat(row['channelCom']);//佣金
            // let goodsCom = parseFloat(row['goodsCom']);//当前结算
            // let total = 0;
            // this.cashConfig.forEach(item => {
            //     let cashNum = parseFloat(item.cashNum); // 转换为数字
            //     if (isNaN(cashNum)) {
            //         console.warn(`Invalid cashNum: ${item.cashNum}`);
            //         return;
            //     }
            //     if (item.cashType && item.cashType == 1) {
            //         cashNum = this.convertProportionToAmount(cashNum,channelCom); // 转换比例为具体金额
            //     }
            //
            //     let cashNum2 = 0;
            //     if (item.cashNum2){
            //         cashNum2 = parseFloat(item.cashNum2); // 转换为数字
            //         if (isNaN(cashNum2)) {
            //             console.warn(`Invalid cashNum2: ${item.cashNum2}`);
            //             return;
            //         }
            //     }
            //
            //     total = total + cashNum + cashNum2;
            // });
            // this.$set(this.cpaSettlePrice, 'estCPATierDiff', this.formatNumber(channelCom-total-goodsCom));
            this.$set(this.cpaSettlePrice, 'estCPATierDiff', this.formatNumber(row['estCPATierDiff']));
            this.$set(this.cashConfig[this.cashConfigMap['4'].sort], 'cashNum2', this.formatNumber(row['taxesAmount']));
            this.priceHisKey += 1;
        },
        buildChannelCashConfig(row){
            this.cashConfig = new Array(Object.keys(this.cashConfigMap).length).fill({});
            this.cashConfig.splice(this.cashConfigMap['1'].sort,1, {
                utype:1, //1.上游商务  2.下游商务 3.公司管理 4.产品运营
                uid:this.goodsInfo['ageRange'],
                uname:"",
                cashType:this.goodsInfo['channelComType'], //提成类型：1按比例 2按金额
                cashNum:this.formatNumber(this.goodsInfo['channelComTimes'],1),  //提成金额或提成比例
            });
            this.cashConfig.splice(this.cashConfigMap['2'].sort,1, {
                utype:2, //1.上游商务  2.下游商务 3.公司管理 4.产品运营
                uid:row['uid'],
                uname:"",
                cashType:row['withdrawal'], //提成类型：1按比例 2按金额
                cashNum:this.formatNumber(row['withdrawalAmount'],1),  //提成金额或提成比例
            });
            this.cashConfig.splice(this.cashConfigMap['3'].sort,1, {
                utype:3, //1.上游商务  2.下游商务 3.公司管理 4.产品运营
                uid:this.goodsInfo['manageUid'],
                uname:"",
                cashType:this.goodsInfo['goodsComType'], //提成类型：1按比例 2按金额
                cashNum:this.formatNumber(this.goodsInfo['goodsComTimes'],1),  //提成金额或提成比例
            });
            this.cashConfig.splice(this.cashConfigMap['4'].sort,1, {
                utype:4, //1.上游商务  2.下游商务 3.公司管理 4.产品运营
                uid:this.goodsInfo['uid'],
                uname:"",
                cashNum:this.formatNumber(this.goodsInfo['coolTime'],3),  //其他费用
                cashNum2:this.formatNumber(row['taxesAmount'],4),  //税费
            });

            const nameMap = {};
            this.cashConfig.forEach(item => {
                nameMap[item.uid] = item;
            });

            fetchUserByIdS({ids:Object.keys(nameMap).join(',')}).then(res=>{
                if(res.code=='200'){
                    this.cashConfig.forEach(cash => {
                        res.data.forEach(item => {
                            if (item.id == cash['uid']) {
                                this.$set(cash,"uname",item.loginName);
                            }
                        });
                    });
                }
            })
        },
        convertProportionToAmount(proportion, totalAmount) {
            let number = (proportion / 100) * totalAmount;
            return Number(number.toFixed(2))
        },
        setMemRiskConfig(row){
            if(row.riskNum<100){
                this.$message.error("渠道风控值不小于100！");
                return;
            }
            if(row.riskPercent>50){
                this.$message.error("渠道转化率不超过50%！");
                return;
            }
            setMemRisk(row).then(res => {   
                if(res.code=='200'){  
                    this.$notify({ title: '成功', message: '渠道:'+row.loginName+' 风控设置成功',duration: 1000, type: 'success' }); 
                }else{
                     this.$notify({ title: '失败', message: '渠道:'+row.loginName+' 风控设置失败：'+res.message,duration: 3000, type: 'error' });
                }
            });
        },
        handleStatus2(rowIndex,row,newValue){
            let _this = this;

            let param = {
                ...row,
            }

            let oldValue = newValue;
            var tips ;
            if(newValue == '0'){
                oldValue = '1';
                tips = "取消分配";
            }else{
                oldValue = '0';
                tips = "分配";
            }

            this.$set(row,"status",oldValue);

            let change = function(row,param){
                param.memId = param.mid;
                changeStatus2(param).then(res => {
                    if(res.code=='200'){
                        _this.$set(row,"status",newValue);
                        _this.$notify({ title: '成功', message: row.loginName+tips+'成功',duration: 1000, type: 'success' });
                    }else{
                        _this.$notify({ title: '失败', message: row.loginName+tips+'失败：'+res.message,duration: 5000, type: 'error' });
                    }
                });
            }

            if (row.status=='0' && row.goodsComHisNumber < 1){
                this.$confirm('当前cpa结算价为系统默认，是否需要调整？', '提示', {
                    confirmButtonText: '立即分配',
                    cancelButtonText: '去调整',
                    type: 'warning'
                }).then(() => {
                    change(row,param);
                }).catch(() => {
                    this.priceHis(rowIndex,row);
                });
                return;
            }

            this.$confirm('确认对《'+row.loginName+"》"+tips+'吗', '提示', {
                type: 'warning'
            }).then(() => {
                change(row,param);
            });
        },
         handleStatus3(row){
            var tips ;
            var content;
            if(row.isStop=='0'){ 
                row.isStop='1';
                tips = "关闭到量"; 
            }else{ 
                row.isStop = '0';
                tips = "设置到量"; 
            }
            this.$confirm('确认对《'+row.loginName+"》"+tips+'吗', '提示', {
                type: 'warning'
            }).then(() => {
                if(row.isStop=='0'){ 
                    row.isStop='1' 
                }else{ 
                    row.isStop='0' 
                }
                row.memId = row.mid;
                changeStatus3(row).then(res => {   
                    if(res.code=='200'){   
                        this.$notify({ title: '成功', message: row.loginName+tips+'成功',duration: 1000, type: 'success' }); 
                    }else{
                        if(row.isStop=='0'){ 
                            row.isStop='1' 
                        }else{ 
                            row.isStop='0' 
                        }
                        this.$notify({ title: '失败', message: row.loginName+tips+'失败：'+res.message,duration: 5000, type: 'error' }); 
                    }
                });
            });
        }, 

        handleStatus4(row){
            var tips ;
            var content;
            if(row.riskStatus=='0'){ 
                row.riskStatus='1';
                tips = "重启风控"; 
            }else{ 
                row.riskStatus = '0';
                tips = "风控关停"; 
            }
            this.$confirm('确认对《'+row.loginName+"》"+tips+'吗', '提示', {
                type: 'warning'
            }).then(() => {
                if(row.riskStatus=='0'){ 
                    row.riskStatus='1' 
                }else{ 
                    row.riskStatus='0' 
                }
                row.memId = row.mid;
                changeStatus4(row).then(res => {   
                    if(res.code=='200'){   
                        this.$notify({ title: '成功', message: row.loginName+tips+'成功',duration: 1000, type: 'success' }); 
                    }else{
                        if(row.riskStatus=='0'){ 
                            row.riskStatus='1' 
                        }else{ 
                            row.riskStatus='0' 
                        }
                        this.$notify({ title: '失败', message: row.loginName+tips+'失败：'+res.message,duration: 5000, type: 'error' });  
                    }
                });
            });
        }, 
        handleStatus5(row){
            var tips ;
            var content;
            if(row.isLink=='0'){ 
                row.isLink='1';
                tips = "关闭专属链接"; 
            }else{ 
                row.isLink = '0';
                tips = "开启专属链接"; 
            }
            this.$confirm('确认对《'+row.loginName+"》"+tips+'吗', '提示', {
                type: 'warning'
            }).then(() => {
                if(row.isLink=='0'){ 
                    row.isLink='1' 
                }else{ 
                    row.isLink='0' 
                }
                row.memId = row.mid;
                changeStatus5(row).then(res => {   
                    if(res.code=='200'){   
                        this.$notify({ title: '成功', message: row.loginName+tips+'成功',duration: 1000, type: 'success' }); 
                    }else{
                        if(row.isLink=='0'){ 
                            row.isLink='1' 
                        }else{ 
                            row.isLink='0' 
                        }
                        this.$notify({ title: '失败', message: row.loginName+tips+'失败：'+res.message,duration: 5000, type: 'error' });  
                    }
                });
            });
        }, 
        getSelect3(){ 
            this.select3 = {}; 
            fetchSelect3(this.select3).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select3, 'option', res.data);  
                }
            });
        },
        
          
        refreshSearch2() {
            this.$set(this.query2, 'mids' ,undefined);
            this.$set(this.query2, 'giveType',undefined);
            this.$set(this.query2, 'isRisk',undefined );
            this.$set(this.query2, 'isDeduc',undefined);
            this.$set(this.query2, 'status',undefined);

            const cleanedQuery = {};
            Object.keys(this.query2).forEach(key => {
                if (this.query2[key] !== undefined && this.query2[key] !== '') {
                    cleanedQuery[key] = this.query2[key];
                }
            });
            this.query2 = cleanedQuery;
            this.getData2();
        },
        handleSearch2(){
            this.$set(this.query2, 'pageIndex', 1);
            this.getData2();
        },
        getData2(fun){
            // 获取列表数据   
            this.loading4 = true;
            fetchDataConfig(this.query2).then(res => {  
                this.loading4 = false;
                if(res.code=='200'){ 
                    this.tableData2 = res.data.list;
                    if (fun){
                        fun();
                    }
                    this.pageTotal2 = res.data.pageTotal || 0;   
                }else{
                    this.tableData2 = []; 
                    this.pageTotal2 = 0;
                }
            });
        },
        priceHis(index,row){
            this.currentRowIndex = index;
            this.query3.goodsCode = this.query2.goodsCode;
            this.query3.memId = row.mid;
            this.query3.price = row.goodsCom;
            // this.get
            this.getData3();
            this.buildChannelCashConfig(row);
            this.initCpaSettlePrice(row);
            this.priceHisVisible = true;

        },
        getData3(){
            this.loading3 = true;
            fetchData3(this.query3).then(res => {
                this.loading3= false;
                if(res.code=='200'){
                    this.tableData3 = res.data.list;
                    this.pageTotal3 = res.data.pageTotal || 0;
                }else{
                    this.tableData3 = [];
                    this.pageTotal3 = 0;
                }
            });
        },
        addBind() {
            this.addPlusVisible = true;
            this.excuteMethodChange(this.form1.excuteMethod);
        },
        saveForm3() {
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.afterNum ){
                this.isSubmitting = false;
                this.$message.error("请填写调整后的结算价");
                return;
            }
            if( !this.form1.excuteDay ){
                this.isSubmitting = false;
                this.$message.error("请选择生效时间");
                return;
            }
            this.form1.memId = this.query3.memId;
            this.form1.goodsCode = this.query3.goodsCode;
            this.form1.beforeNum = this.query3.price;
            this.loading = true;
            saveForm3(this.form1).then(res => {
                this.loading = false;
                this.isSubmitting = false;
                if(res.code=='200'){
                    this.addPlusVisible = false;
                    this.$message.success(res.message);
                    this.getData3();
                    this.getData2(()=>{
                        let data = this.tableData2[this.currentRowIndex]
                        this.buildChannelCashConfig(data);
                        this.initCpaSettlePrice(data);
                    });
                }else{
                    this.$message.error(res.message);
                }
            });
        },
        handDelete(index, row) {
            handDelete3(row).then(res => {
                if(res.code=='200'){
                    this.$message.success('删除成功');
                    this.getData3();
                }else{
                    this.$message.error(res.message);
                }
            });
        },
          
         //刷新
        refresh(){
            history.go(0); 
        },
         
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val; 
        },
         
         
        validateNumberInput(input) {
            // 使用正则表达式替换非数字和小数点的字符
            input.value = input.value.replace(/[^0-9.]/g, '');

            // 确保只有一个小数点
            let parts = input.value.split('.');
            if (parts.length > 2) {
                input.value = parts[0] + '.' + parts.slice(1).join('');
            }

            // 确保不以小数点开头
            if (input.value.startsWith('.')) {
                input.value = input.value.substring(1);
            }
        },

        getCurrentDateTime() {
            const now = new Date();
            return {
                year: now.getFullYear(),
                month: String(now.getMonth() + 1).padStart(2, '0'),
                day: String(now.getDate()).padStart(2, '0'),
                hours: String(now.getHours()).padStart(2, '0'),
                minutes: String(now.getMinutes()).padStart(2, '0'),
            };
        },
        
        // 分页导航
        handlePageChange2(val) { 
            this.$set(this.query2, 'pageIndex', val);
            this.getData2();
        },
        //分页数量更改导航
        handleSizeChange2(val){
            this.$set(this.query2, 'pageSize', val);
            this.getData2();
        },
        handlePageChange3(val) {
            this.$set(this.query3, 'pageIndex', val);
            this.getData3();
        },
        //分页数量更改导航
        handleSizeChange3(val){
            this.$set(this.query3, 'pageSize', val);
            this.getData3();
        }
    }
};
</script>
<style> 
.chm-imgUl{
   width:560px;height:250px;margin-top:15px;
}
.chm-imgLi{
    list-style: none;
    float:left;width:100px;
    padding:0 20px;
}
.chm-imgFag{
    font-size: 35px;
    color: #ccc;
    position: relative;
    top: -100px;
    left: 30px;
}
.chm-imgDiv{
     position: relative;width: 100px;height: 160px; margin-top:-200px;border: 1px solid #eee;border-radius: 5px;background-color:#eee;opacity:0;box-sizing: border-box;
}
.chm-imgInput{
     width: 100px; height: 160px; cursor: pointer; 
}
.chm-imgTip{
    width:100px;
    background:rgb(245, 105, 24);
    color:#fff;
    height:35px;
    font-size: 13px;
    line-height:35px;
    display:inline-block;
    text-align: center;;
    margin-top:10px;
}
.el-dialog__title{
    font-size: 15px;;
}
 
.el-upload-list--picture-card .el-upload-list__item{
    width:80px ;
    height:80px ;
}
.el-upload--picture-card{
    width:80px ;
    height:80px ;
    line-height:80px ;
}

.ql-container{
    min-height:150px; 
  }
.ql-editor{
	height: 150px;
}
.contentHei .ql-editor{
    height: 450px;
}
#input_box{
	height: 100px;
	padding: 0 10px;
	font-size: 12px;
	word-wrap:break-word;/*为了在ie和FF顺利换行，加上word-wrap*/
	overflow-x:hidden;
	overflow-y: auto; /*visible (默认), hidden, scroll, 和auto*/
	outline:none;
    border:1px solid #ddd;
    border-radius:5px;
    line-height: 15px;
}
#input_box2{
	height: 100px;
	padding: 0 10px;
	font-size: 12px;
	word-wrap:break-word;/*为了在ie和FF顺利换行，加上word-wrap*/
	overflow-x:hidden;
	overflow-y: auto; /*visible (默认), hidden, scroll, 和auto*/
	outline:none;
    border:1px solid #ddd;
    border-radius:5px;
    line-height: 15px;
}
#input_box3{
	height: 100px;
	padding: 0 10px;
	font-size: 12px;
	word-wrap:break-word;/*为了在ie和FF顺利换行，加上word-wrap*/
	overflow-x:hidden;
	overflow-y: auto; /*visible (默认), hidden, scroll, 和auto*/
	outline:none;
    border:1px solid #ddd;
    border-radius:5px;
    line-height: 15px;
}
.imgOper{
    margin-top: -45px; 
    font-size: 18px; 
    float: right;
    margin-right: 20px;
}
.imgOper span{
    margin-right:20px;
}
.imgOper i{
    margin-right:10px;
}
    .el-dialog__body{
        padding:10px 20px;
    }
    .el-dialog__footer{
        padding: 0px 20px 20px;
    }
    .overflowy{

    overflow-x: hidden; /* 设置溢出滚动 */
   white-space: nowrap;
   overflow-y: scroll;
   /* 隐藏滚动条 */
   scrollbar-width: none; /* firefox */
   -ms-overflow-style: none; /* IE 10+ */
}
.overflowy::-webkit-scrollbar {
    display: none; /* Chrome Safari */
 
}
</style>
<style scoped> 
.layerDiv{
    position:fixed;
    height:200px;
    background: #333;
    opacity:0.7;
    z-index:100;
}
.input{
    width:80px;height:27px;line-height:27px;text-align:center;color:#ff2222;border:1px solid #aaa;border-radius:5px;font-weight:700 
}
.input:focus {
    outline:none;
    border: 1px solid #fb8a11;
}
.redSpan{
    width:80px;height:30px;line-height:30px;display:inline-block;text-align:center;color:#ff2222;font-weight:700 
}
.titleInfo{
    width:100%;
    text-align: center;
    line-height: 30px;
    height: 30px;
    font-size: 14px;
    color:#fff; 
    background:#0094d8;
    margin:-10px 0 10px 0; 
}
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    margin-bottom:5px;
    width: 120px;
    display: inline-block;
}

.handle-input {
    margin-bottom:5px;
    width: 180px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

/**/
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
@media screen and (max-width:999px){ 
  
 .goodDetails{
        font-size:12px;line-height:15px;height:18px;overflow-y:auto;
    }
    .goodRight{
        display:block;
    }
} 
@media screen and (min-width:999px){ 
    .goodDetails{
        font-size:15px;line-height:20px;height:22px;overflow-y:auto;
    }
    .goodRight{
        position:absolute;
        left:130px;
    }
}
input.notborder[disabled] {
    border-bottom: none; /* 移除边框 */
    cursor: not-allowed; /* 禁用光标 */
}
.inputStyle{
    height:28px; 
    text-align:center; 
    border:none;
    border-bottom:1px solid orange;
    background: none;
    color:orange;
}

.inputStyle::placeholder{
    color:#bbb;
}
.inputStyle:focus {
    outline:none;
    border-bottom:2px solid red;
}

</style>
